import { NextStep } from '@components/next-step/next-step';

// This page will be used to navigate to the next step in the child account process.
export const NextStepPage = () => <NextStep />;
